import { render } from "./Report.vue?vue&type=template&id=37d9df08"
import script from "./Report.vue?vue&type=script&lang=js"
export * from "./Report.vue?vue&type=script&lang=js"
script.render = render

export default script